/* import __COLOCATED_TEMPLATE__ from './upgrade-button-light.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();